<div>
    <ng-container *ngIf="(content | async) as content">
        <h3 class="c-modal__title" *ngIf="content.title">{{content.title}}</h3>
        <article class="c-modal__message" [innerHTML]="content.body"></article>
        <div>
            <!-- <span>Your download will begin in a moment. If it doesn't, </span> -->
            <a id="cpp-download-file"  class="cpp-button cpp-button--happy" target="_blank" [href]="erpxFileUrl">{{ labels['downloads.consent.button'] }}</a>
        </div>
    </ng-container>
</div>
